//////////////////////////////////////
// TRAVELING CLINIC CALENDAR

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    //////////////////////////////////////
    // DATA

    const blocks = document.querySelectorAll('.traveling-clinic-calendar');
    if (!blocks.length) return;

    blocks.forEach((block) => { initCalendar(block); });
  });


  //////////////////////////////////////
  // INIT (per instance)

  function initCalendar(block) {

    //////////////////////////////////////
    // DATA

    const scriptEl = block.querySelector('script.events-data');
    if (!scriptEl) return;

    let payload;
    try {
      payload = JSON.parse(scriptEl.textContent);
    } catch (e) {
      return;
    }

    const { months, monthLabels, eventsByMonth } = payload;
    if (!months || !months.length) return;


    //////////////////////////////////////
    // STATE

    let currentMonth     = block.dataset.currentMonth || months[0];
    let currentIndex     = months.indexOf(currentMonth);
    if (currentIndex === -1) currentIndex = 0;
    let currentCommunity = '';
    let currentService   = '';


    //////////////////////////////////////
    // DOM REFS

    const monthEl       = block.querySelector('.month');
    const prevBtn       = block.querySelector('.prev');
    const nextBtn       = block.querySelector('.next');
    const eventsEl      = block.querySelector('.events');
    const communitySel  = block.querySelector('.community-filter select');
    const serviceSel    = block.querySelector('.service-filter select');
    const resetBtn      = block.querySelector('.reset');


    //////////////////////////////////////
    // HELPERS

    // Clone SVG prototypes from first server-rendered card; reused in JS-built cards
    const firstIconSvg = block.querySelector('.event-card .icon svg');
    const iconSvg      = firstIconSvg ? firstIconSvg.outerHTML : '';

    const firstTimeSvg = block.querySelector('.event-card .time svg');
    const timeSvg      = firstTimeSvg ? firstTimeSvg.outerHTML : '';

    const esc = (str) => {
      const d = document.createElement('div');
      d.textContent = str || '';
      return d.innerHTML;
    };

    const formatDate = (dateKey) => {
      const [y, m, d] = dateKey.split('-').map(Number);
      return new Date(y, m - 1, d).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const buildCard = ({ service, provider, community, description, time, isAllDay }) => {
      const whoItems = [];
      if (provider)              whoItems.push(`<strong class="provider">${esc(provider)}</strong>`);
      if (provider && community) whoItems.push(`<span class="sep">|</span>`);
      if (community)             whoItems.push(`<span class="community">${esc(community)}</span>`);

      const whoHTML  = whoItems.length ? `<p class="who">${whoItems.join('')}</p>` : '';
      const descHTML = description     ? `<p class="description">${esc(description)}</p>` : '';
      const metaHTML = (whoHTML || descHTML) ? `<div class="meta">${whoHTML}${descHTML}</div>` : '';
      const timeText = isAllDay ? 'All Day' : time;

      return `<article class="event-card">` +
        `<span class="icon">${iconSvg}</span>` +
        `<h4 class="service">${esc(service)}</h4>` +
        `${metaHTML}` +
        `<p class="time">${timeSvg}${esc(timeText)}</p>` +
        `</article>`;
    };

    const buildDateGroup = (dateKey, events) => {
      const label = formatDate(dateKey);
      const cards = events.map(buildCard).join('');
      return `<div class="date-group"><h3 class="date">${esc(label)}</h3>${cards}</div>`;
    };

    // Returns a new monthData object with events filtered by current community.
    // Skips empty days entirely. If no community filter is active, returns input.
    const applyFilters = (monthData) => {
      if (!currentCommunity && !currentService) return monthData;
      const out = {};
      Object.keys(monthData).forEach((dateKey) => {
        const matches = monthData[dateKey].filter((ev) => {
          if (currentCommunity && ev.community !== currentCommunity) return false;
          if (currentService && ev.serviceCategory !== currentService) return false;
          return true;
        });
        if (matches.length) out[dateKey] = matches;
      });
      return out;
    };

    const isFilterActive = () => Boolean(currentCommunity || currentService);


    //////////////////////////////////////
    // RENDER

    const updateNav = () => {
      const atStart = currentIndex <= 0;
      const atEnd   = currentIndex >= months.length - 1;

      prevBtn.disabled = atStart;
      prevBtn.setAttribute('aria-disabled', String(atStart));
      nextBtn.disabled = atEnd;
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    };

    const renderMonth = () => {
      currentMonth = months[currentIndex];

      if (monthEl)  monthEl.textContent    = monthLabels[currentMonth] || currentMonth;
      block.dataset.currentMonth           = currentMonth;

      if (eventsEl) {
        const monthData = applyFilters(eventsByMonth[currentMonth] || {});
        const dateKeys  = Object.keys(monthData);
        if (dateKeys.length) {
          eventsEl.innerHTML = dateKeys
            .map((dateKey) => buildDateGroup(dateKey, monthData[dateKey]))
            .join('');
        } else {
          const label   = monthLabels[currentMonth] || currentMonth;
          const subject = currentService ? `${esc(currentService)} clinics` : 'Traveling Clinics';
          const where   = currentCommunity ? ` in ${esc(currentCommunity)}` : '';
          eventsEl.innerHTML = `<p class="no-events">There are no ${subject} scheduled${where} for ${esc(label)}. Please check back for future updates.</p>`;
        }
      }

      updateNav();
      updateResetState();
    };

    const updateResetState = () => {
      if (!resetBtn) return;
      resetBtn.classList.toggle('active', isFilterActive());
    };


    //////////////////////////////////////
    // EVENTS

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        renderMonth();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentIndex < months.length - 1) {
        currentIndex++;
        renderMonth();
      }
    });


    if (communitySel) {
      communitySel.addEventListener('change', () => {
        currentCommunity = communitySel.value;
        renderMonth();
      });
    }

    if (serviceSel) {
      serviceSel.addEventListener('change', () => {
        currentService = serviceSel.value;
        renderMonth();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        if (!isFilterActive()) return;
        currentCommunity = '';
        currentService   = '';
        if (communitySel) communitySel.value = '';
        if (serviceSel)   serviceSel.value   = '';
        renderMonth();
      });
    }


    //////////////////////////////////////
    // INIT

    // Server already rendered the initial month — just wire nav state
    updateNav();
    updateResetState();
  }

})();
